import React from 'react';
import lightTheme from '../theme/themes/light';
var ThemeContext = /*#__PURE__*/React.createContext(lightTheme);
export default ThemeContext;